import { render, staticRenderFns } from "./EditPersonModal.vue?vue&type=template&id=35bb5336&scoped=true&"
import script from "./EditPersonModal.vue?vue&type=script&lang=js&"
export * from "./EditPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonModal.vue?vue&type=style&index=0&id=35bb5336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb5336",
  null
  
)

export default component.exports